import { FabricObject } from 'fabric';

import { DRAW_OBJECT_TYPE_TRIANGLE } from '../draw-canvas.constants';

export const isTriangle = (object: FabricObject) => {
  return object.type.toLowerCase() === DRAW_OBJECT_TYPE_TRIANGLE;
};
